import React from "react";
import Card from "react-bootstrap/Card";
import Container from "react-bootstrap/Container";
import Fade from "react-bootstrap/Fade";

export function CardWrapper(props) {
    return (
        <Fade appear={true} in={true}>
            <Card className="shadow rounded">
                <Card.Body>
                    <Container>
                        {props.children}
                    </Container>
                </Card.Body>
            </Card>
        </Fade>
    );
}